import { OS } from "@lib/common-interfaces/app";

export function isIos(os: string): boolean {
  return !!os && os.toLowerCase() === OS.IOS.toLowerCase();
}

export function isMacOS(os: string): boolean {
  return !!os && os.toLowerCase() === OS.MACOS.toLowerCase();
}

export function isAndroid(os: string): boolean {
  return !!os && os.toLowerCase() === OS.ANDROID.toLowerCase();
}

export function isWindows(os: string): boolean {
  return !!os && os.toLowerCase().startsWith(OS.WINDOWS.toLowerCase());
}

export function isLinux(os: string): boolean {
  return !!os && os.toLowerCase().startsWith(OS.LINUX.toLowerCase());
}
